const normalizeLanguage = (language) => {
  const raw = String(language || "pt").toLowerCase();
  return raw.split("-")[0];
};

const dictionaries = {
  pt: {
    search: "Pesquisar",
    clear: "Limpar",
    notfound: "Nenhum emoji encontrado",
    skintext: "Escolha o tom de pele padrão",
    categories: {
      search: "Pesquisar",
      recent: "Usados com frequência",
      people: "Emojis e pessoas",
      nature: "Animais e natureza",
      foods: "Comidas e bebidas",
      activity: "Atividades",
      places: "Viagens e lugares",
      objects: "Objetos",
      symbols: "Símbolos",
      flags: "Bandeiras",
      custom: "Personalizados"
    }
  },
  es: {
    search: "Buscar",
    clear: "Limpiar",
    notfound: "No se encontraron emojis",
    skintext: "Elige el tono de piel predeterminado",
    categories: {
      search: "Buscar",
      recent: "Usados con frecuencia",
      people: "Emojis y personas",
      nature: "Animales y naturaleza",
      foods: "Comidas y bebidas",
      activity: "Actividades",
      places: "Viajes y lugares",
      objects: "Objetos",
      symbols: "Símbolos",
      flags: "Banderas",
      custom: "Personalizados"
    }
  },
  en: {
    search: "Search",
    clear: "Clear",
    notfound: "No Emoji Found",
    skintext: "Choose your default skin tone",
    categories: {
      search: "Search",
      recent: "Frequently Used",
      people: "Smileys & People",
      nature: "Animals & Nature",
      foods: "Food & Drink",
      activity: "Activity",
      places: "Travel & Places",
      objects: "Objects",
      symbols: "Symbols",
      flags: "Flags",
      custom: "Custom"
    }
  }
};

export const getEmojiMartI18n = (language) => {
  const normalized = normalizeLanguage(language);
  return dictionaries[normalized] || dictionaries.pt;
};

